<template>
  <div class="not-found">
    <div class="title">404 Not Found!</div>
    <p>Whoops! The page you are trying to access doesn't exist.</p>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
};
</script>

<style lang="scss">
.not-found {
  padding-top: 10rem;
  max-width: 600px;
  margin: 0 auto;
  .title {
    font-size: 6rem;
  }
}
</style>
